import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';
import { CODE_VALUE_TAG } from './codeValuesApi';

const CODES_TAG = 'Codes';

dcpcApi.enhanceEndpoints({ addTagTypes: [CODES_TAG] });

const codesApi = dcpcApi.injectEndpoints({
    endpoints: (builder) => ({
        getCodes: builder.query({
            query: () => 'codes',
            providesTags: [CODES_TAG],
        }),
        getCode: builder.query({
            query: (id) => `code/${id}`,
            providesTags: [CODES_TAG],
        }),
        updateCode: builder.mutation({
            query: (args) => ({
                url: `code/${args.id || ''}`,
                method: args.id ? 'PUT' : 'POST',
                body: args,
            }),
            invalidatesTags: [CODES_TAG],
        }),
        getCodeValues: builder.query({
            query: (id) => `code/${id}/values`,
            providesTags: [CODE_VALUE_TAG],
        }),
        getCodeParameters: builder.query({
            query: (id) => `code/${id}/parameters`,
        }),
    }),
});
export const {
    useGetCodesQuery,
    useGetCodeQuery,
    useUpdateCodeMutation,
    useGetCodeValuesQuery,
    useGetCodeParametersQuery,
} = codesApi;

export const codesSelect = (state) => codesApi.endpoints.getCodes.select()(state);
export const codesSelector = (state) => codesSelect(state).data || [];

export const filterCodesBySearchTextSelector = createSelector(
    codesSelector,
    (_, searchText) => searchText,
    (codes, searchText) => ({
        columns: [
            {
                label: 'Код',
            },
            {
                label: 'Описание',
            },
            {
                label: 'Короткое описание',
            },
            {
                label: 'Системная единица измерения',
            },
        ],
        rows: codes.reduce((acc, cur) => {
            const {
                id, code, description, shortName, unit, // проверка на наличие UNIT
            } = cur;
            const row = [id, code, description, shortName, unit ? unit.unit : ''].map((v) => v || '');
            if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
                acc.push(row);
            }
            return acc;
        }, []),
        rowButtons: [
            {
                label: 'Редактировать',
                to: (id) => `${id}`, // переход на форму редактирования
                icon: EditIcon,
            },
        ],
        createLink: {
            label: 'Создать код',
        },
    }),
);
export const codesBySearchTextSelector = (searchText) => (state) => filterCodesBySearchTextSelector(state, searchText);
